import Vue from 'vue'

Vue.component('section-header', () => import('@/components/SectionHeader'))
